import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3d5322da = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _30f83086 = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _de5e4e96 = () => interopDefault(import('../modules/pageExten/pages/CnfStore.vue' /* webpackChunkName: "" */))
const _13d1b347 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _9bb59496 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _936043e0 = () => interopDefault(import('../modules/customer/pages/MyAccount/MembershipCard.vue' /* webpackChunkName: "" */))
const _58ba9175 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyAccount.vue' /* webpackChunkName: "" */))
const _33c30a7c = () => interopDefault(import('../modules/customer/pages/MyAccount/MyCoupon.vue' /* webpackChunkName: "" */))
const _2fb172f1 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _355c5aa2 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyRecentlyViewed.vue' /* webpackChunkName: "" */))
const _1658491b = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _101730f5 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _77d4bbdc = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrderNew.vue' /* webpackChunkName: "" */))
const _033f2726 = () => interopDefault(import('../modules/pageExten/pages/FaqPage.vue' /* webpackChunkName: "" */))
const _57e97b72 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "pages/Home" */))
const _79aa4d34 = () => interopDefault(import('../pages/Login.vue' /* webpackChunkName: "pages/Login" */))
const _1e29b94e = () => interopDefault(import('../modules/singlePage/pages/Membership.vue' /* webpackChunkName: "" */))
const _4cab860a = () => interopDefault(import('../modules/checkout/pages/OderShopeePayment.vue' /* webpackChunkName: "" */))
const _20db3e73 = () => interopDefault(import('../modules/checkout/pages/OderPaymentOnline.vue' /* webpackChunkName: "" */))
const _afc2ddbc = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _1e956aaa = () => interopDefault(import('../pages/SearchPage.vue' /* webpackChunkName: "" */))
const _58fdfdd5 = () => interopDefault(import('../modules/pageExten/pages/CheckOrder.vue' /* webpackChunkName: "" */))
const _5db24074 = () => interopDefault(import('../modules/pageExten/pages/Vouchers.vue' /* webpackChunkName: "" */))
const _4c5d3152 = () => interopDefault(import('../modules/pageExten/pages/FaqDetailPage.vue' /* webpackChunkName: "" */))
const _6638f1c6 = () => interopDefault(import('../modules/pageExten/pages/FlashDeal.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _3d5322da,
    meta: {"layout":"checkout"},
    name: "checkout___vi"
  }, {
    path: "/Cms",
    component: _30f83086,
    name: "Cms___vi"
  }, {
    path: "/cua-hang.html",
    component: _de5e4e96,
    name: "cua-hang___vi"
  }, {
    path: "/customer",
    component: _13d1b347,
    meta: {"titleLabel":"Account"},
    name: "customer___vi",
    children: [{
      path: "addresses-details",
      component: _9bb59496,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___vi"
    }, {
      path: "membership-card",
      component: _936043e0,
      meta: {"titleLabel":"Membership Card"},
      name: "customer-membership-card___vi"
    }, {
      path: "my-account",
      component: _58ba9175,
      meta: {"titleLabel":"My Account"},
      name: "customer-my-account___vi"
    }, {
      path: "my-coupon",
      component: _33c30a7c,
      meta: {"titleLabel":"My Coupon"},
      name: "customer-my-coupon___vi"
    }, {
      path: "my-profile",
      component: _2fb172f1,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___vi"
    }, {
      path: "my-recently-viewed",
      component: _355c5aa2,
      meta: {"titleLabel":"My Recently Viewed"},
      name: "customer-my-recently-viewed___vi"
    }, {
      path: "my-wishlist",
      component: _1658491b,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___vi"
    }, {
      path: "order-history",
      component: _101730f5,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___vi"
    }, {
      path: "order-history/:orderId",
      component: _77d4bbdc,
      meta: {"titleLabel":"Order history"},
      name: "customer-single-order___vi"
    }]
  }, {
    path: "/hoi-dap",
    component: _033f2726,
    name: "faq___vi"
  }, {
    path: "/Home",
    component: _57e97b72,
    name: "Home___vi"
  }, {
    path: "/Login",
    component: _79aa4d34,
    name: "Login___vi"
  }, {
    path: "/membership",
    component: _1e29b94e,
    meta: {"layout":"empty"},
    name: "membership___vi"
  }, {
    path: "/odershopeepayment",
    component: _4cab860a,
    name: "odershopeepayment___vi"
  }, {
    path: "/orderdetailpayonline",
    component: _20db3e73,
    name: "orderdetailpayonline___vi"
  }, {
    path: "/Page",
    component: _afc2ddbc,
    name: "Page___vi"
  }, {
    path: "/search",
    component: _1e956aaa,
    name: "search___vi"
  }, {
    path: "/SearchPage",
    component: _1e956aaa,
    name: "SearchPage___vi"
  }, {
    path: "/tra-don-hang",
    component: _58fdfdd5,
    name: "check-order___vi"
  }, {
    path: "/vouchers",
    component: _5db24074,
    name: "vouchers___vi"
  }, {
    path: "/hoi-dap/tim-kiem",
    component: _4c5d3152,
    name: "faq-search___vi"
  }, {
    path: "/flash-deal/:id",
    component: _6638f1c6,
    name: "flash-deal___vi"
  }, {
    path: "/supportdetail/:faq_group_id",
    component: _4c5d3152,
    name: "faq-detail___vi"
  }, {
    path: "/",
    component: _57e97b72,
    name: "home___vi"
  }, {
    path: "/:slug+",
    component: _afc2ddbc,
    name: "page___vi"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
